export default __webpack_public_path__ + "143d5ee3.jpg";